export default {"src":"/_next/static/media/business.79157698.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};